import React from "react"
import { Navbar, NavDropdown } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { HiUserCircle, HiOutlineUserCircle, HiLogout } from "react-icons/hi"

import LanguagePicker from "./languagePicker"
import Feedback from "./feedback"
import { useAuth } from "../contexts/AuthContext"
import { useLogout } from "../hooks/useAuthMutations"

const Header: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const { user } = useAuth()
  const logoutMutation = useLogout()

  const onLogout = async () => {
    try {
      await logoutMutation.mutateAsync()
      history.push("/login")
    } catch {
      // ignore
    }
  }

  return (
    <Navbar bg="white" className="header-navigation">
      <Feedback />
      <NavDropdown
        title={<HiUserCircle className="tw-text-2xl" />}
        id="user-details-dropdown"
        alignRight
        className="bl-2">
        <NavDropdown.Header>{user?.email || ""}</NavDropdown.Header>
        <NavDropdown.Item onClick={() => history.push("/settings/account")}>
          <HiOutlineUserCircle />
          <span className="tw-pl-2">{t("header.accounts")}</span>
        </NavDropdown.Item>
        <NavDropdown.Item onClick={onLogout}>
          <HiLogout />
          <span className="tw-pl-2">{t("header.logout")}</span>
        </NavDropdown.Item>
      </NavDropdown>
      <LanguagePicker className="bl-2" />
    </Navbar>
  )
}

export default Header
